import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function NewsletterThirtyOne() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter April 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            IFRS Launches Roadmap Tool to Accelerate ISSB Standards Adoption.
          </title>
          <meta
            name="description"
            content="The International Financial Reporting Standards (IFRS) Foundation has launched a Roadmap Development Tool to support jurisdictions in adopting the International Sustainability Standards Board (ISSB) Standards."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          IFRS Launches Roadmap Tool to Accelerate ISSB Standards Adoption.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/apr2025_ifrs.webp")}
            alt="ifrs"
          />
        </figure>
        <p>
          The International Financial Reporting Standards (IFRS) Foundation has
          launched a Roadmap Development Tool to support jurisdictions in
          adopting the International Sustainability Standards Board (ISSB)
          Standards. This tool offers a structured framework to help
          policymakers integrate sustainability disclosure requirements into
          national reporting systems, aiming to establish a consistent and
          comparable global foundation for sustainability reporting.
        </p>
        <p>
          The IFRS Foundation stated that the launch of the tool marks a
          significant step in its mission to support effective and efficient
          capital markets. It equips regulators with the necessary resources to
          make well-informed decisions on how to adopt or apply ISSB Standards.
          The tool is also positioned as a central resource for implementation
          partners working with jurisdictions to advance their sustainability
          reporting plans. The organization highlighted its commitment to
          continued collaboration with regulators and partners, emphasizing the
          long-term impact this tool is expected to have.
        </p>
        <p>
          Jurisdictions using the tool can make informed decisions across four
          key areas. These include selecting the appropriate regulatory process
          for adoption, determining which entities will be subject to reporting
          requirements, defining the specific content to be disclosed, and
          setting effective timelines for implementation. The tool also supports
          considerations around readiness, including whether requirements should
          be phased in or scaled. More than 30 jurisdictions, representing over
          half of the global economy, are progressing toward using ISSB
          Standards. Countries such as China, Brazil, Australia and members of
          the European Union have already taken active steps in this direction.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The tool will help companies align with global expectations,
            reducing fragmentation and enhancing credibility with investors. It
            encourages strategic integration of sustainability into core
            operations, fostering long-term resilience. By anticipating
            regulatory trends, companies can move from reactive compliance to
            proactive leadership, positioning themselves competitively in a
            rapidly shifting global landscape.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EU Launches Comprehensive Plan to Support Decarbonisation of Steel and
          Metals Industry.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/images/apr2025_steel.webp")}
              alt="steel_metal"
            />
          </figure>
        </div>
        <p>
          The European Commission has unveiled a comprehensive Action Plan to
          accelerate the decarbonization and competitiveness of the steel and
          metals industry—an essential move as the sector contributes about 7%
          of global CO₂ emissions. The strategy centers on five pillars: cutting
          energy costs, promoting low-carbon technologies, enhancing
          circularity, shielding against unfair global competition, and
          de-risking industrial investment. A €100 billion investment is in
          sight through the upcoming Industrial Decarbonisation Bank, with a €1
          billion pilot auction already planned for 2025.
        </p>
        <p>
          Steel remains a strategic asset in Europe, supplying critical sectors
          like automotive, defence, and clean tech. However, global
          overcapacity, energy price volatility, and carbon leakage pose serious
          threats. The EU aims to bolster industrial sovereignty by tightening
          trade defense measures and introducing origin-tracing rules for metal
          goods. The plan also proposes recycling targets and incentives to
          expand use of low-carbon hydrogen and scrap-based production, aiming
          to reduce reliance on blast furnaces.
        </p>
        <p>
          The Commission is aligning funding streams through Horizon Europe, the
          Innovation Fund, and the Clean Steel Partnership, driving development
          of hydrogen-based technologies, digital twins for process
          optimization, and advanced scrap valorization techniques. With €750
          million earmarked through 2027 for R&D alone, the EU is positioning
          itself as a frontrunner in green steel innovation and industrial
          climate transition​.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The European Steel and Metals Action Plan reduces cost pressures
            through energy tax flexibility and improved grid access, while
            incentivising low-carbon and hydrogen-based technologies. It
            establishes lead markets via green public procurement and enforces
            circularity with recycled content targets. These targeted
            interventions enhance industrial competitiveness, de-risk capital
            investments, and secure critical value chains across defence, clean
            tech, and manufacturing sectors.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          SBTi Strengthens Corporate Net-Zero Standard to Drive Decarbonization.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/apr2025_decarbon.webp")}
            alt="decarbonisation"
          />
        </figure>
        <p>
          The Science Based Targets initiative has released a draft of its
          updated Corporate Net Zero Standard for public consultation. This
          revision aims to accelerate corporate decarbonization by addressing
          key challenges, including scope 3 emissions which are often the most
          significant hurdle for businesses. The draft introduces flexible
          options such as setting targets for green procurement and revenue
          generation, focusing on direct suppliers and emissions intensive
          sectors to enhance impact.
        </p>
        <p>
          The proposed standard emphasizes direct emissions reductions while
          exploring incentives to scale climate finance and carbon removals. It
          suggests setting carbon removal targets and allows companies to set
          their own targets or use a combination of reductions and removals for
          residual emissions. This approach acknowledges the necessity of carbon
          removals for addressing hard to abate emissions, incorporating
          considerations for the durability and emissions intensity of the
          technologies used.
        </p>
        <p>
          Additionally, the draft standard proposes simplified requirements for
          medium sized companies in developing markets and small enterprises,
          offering streamlined processes that reflect their capabilities and
          resources. To ensure a smooth transition from the existing standard,
          the Science Based Targets initiative plans to develop a comprehensive
          pathway, encouraging companies to continue setting targets during the
          revision process. The public consultation is open until June 1,
          inviting stakeholders to contribute feedback to refine the standard
          effectively.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Companies must embed sustainability into core strategies by
            reimagining value chains, integrating regenerative business models,
            and leveraging technology for predictive carbon management. The
            Science Based Targets initiative's updated Net-Zero Standard
            encourages businesses to set flexible yet ambitious climate targets,
            particularly for scope 3 emissions, which require systemic
            transformation. Shifting from compliance-driven actions to proactive
            climate leadership, companies should foster ecosystem-wide
            collaborations, embed circular economy principles, and innovate
            financial mechanisms that align profitability with long-term
            environmental resilience.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          ASIC Introduces Mandatory Climate Reporting Framework for Australian
          Companies.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/apr2025_crf.webp")}
            alt="Climate Reporting Framework"
          />
        </figure>
        <p>
          Australia has formalised its approach to climate-related financial
          disclosure with the release of Regulatory Guide 280, published by the
          Australian Securities and Investments Commission (ASIC). Beginning in
          2025, sustainability reporting will become mandatory for large and
          medium-sized companies that meet certain thresholds under the
          Corporations Act. The reports must comply with the Australian
          Accounting Standards Board’s AASB S2, which is based on the
          International Sustainability Standards Board’s IFRS S2 framework.
          Required disclosures include material climate-related financial risks
          and opportunities, climate scenario analysis, transition plans, and
          Scope 3 greenhouse gas emissions. Each report must also include a
          director’s declaration confirming reasonable efforts to ensure
          compliance.
        </p>
        <p>
          The rollout will occur in three phases based on company size. The
          first group includes entities with over 500 employees, at least one
          billion dollars in assets, or five hundred million dollars in revenue.
          Over the following two years, thresholds will lower to include smaller
          companies, with the third phase capturing those with just one hundred
          employees or fifty million dollars in revenue. Entities must also
          maintain detailed sustainability records for at least seven years.
          These records should support all disclosures made in the report and
          include evidence such as internal documentation, board meeting
          minutes, third-party analyses, and greenhouse gas inventories. The
          reports must contain climate statements, explanatory notes, and be
          lodged within three or four months of the end of the financial year,
          depending on the entity’s classification. Forward-looking statements,
          Scope 3 emissions, and scenario analyses will have limited liability
          protections during the initial implementation years. This ensures
          companies can develop reporting capabilities without facing immediate
          legal exposure for complex or evolving data points.
        </p>
        <p>
          ASIC has confirmed it will take a measured approach to enforcement,
          prioritising egregious or misleading disclosures while allowing time
          for entities to improve practices and build internal systems. This
          marks a significant shift in Australia’s corporate landscape and
          signals a clear move toward more transparent, accountable
          sustainability practices.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To adhere effectively to ASIC’s Regulatory Guide 280 and AASB S2
            standards, companies should integrate climate risk into enterprise
            risk management frameworks, invest in systems to capture Scope 3
            emissions, and align internal reporting processes with AASB S2
            requirements. Establishing cross-functional ESG committees, running
            climate scenario analyses, and securing third-party assurance will
            help ensure compliance and build investor confidence.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          CDP and EFRAG Align Climate Disclosure Frameworks for Streamlined
          Reporting.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/apr2025_cdfr.webp")}
            alt="Qatar"
          />
        </figure>

        <p>
          CDP and EFRAG have released a correspondence mapping between CDP’s
          climate disclosure questionnaire and the European Sustainability
          Reporting Standards (ESRS E1). The document highlights areas of strong
          alignment, including Scope 1, 2, and 3 emissions, climate transition
          planning, internal carbon pricing, and climate-related targets. This
          effort is designed to help companies meet both voluntary and
          regulatory reporting requirements more efficiently.
        </p>
        <p>
          The mapping serves as a practical reference for organizations
          preparing for compliance with the EU’s Corporate Sustainability
          Reporting Directive (CSRD). It enables companies to streamline their
          reporting processes by identifying overlaps in data requirements,
          thereby improving efficiency and reducing duplication. The tool also
          helps integrate climate-related data more consistently across
          different frameworks, improving the reliability of disclosures for
          investors and regulators.
        </p>
        <p>
          In addition to simplifying corporate reporting, the collaboration
          supports a broader push for global alignment across sustainability
          standards. As regulatory expectations increase, such cooperation helps
          organizations better manage climate-related risks and improve
          transparency for investors, regulators, and other stakeholders.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The correspondence mapping reinforces the role of climate-related
            disclosures in capital markets and regulatory decision-making. With
            CDP widely used by over 23,000 companies globally and ESRS set to
            become mandatory under CSRD for thousands of European firms, the
            mapping encourages convergence at scale. By highlighting
            commonalities between voluntary and mandatory frameworks, the
            mapping supports companies in adopting a unified approach to
            sustainability reporting. It can also reduce the cost and complexity
            of compliance, especially for multinational companies reporting
            across multiple jurisdictions.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default NewsletterThirtyOne;
